mutation SendContractPaymentInvoice($id: ID!) {
  sendContractPaymentInvoice(id: $id) {
    id
    invoiceUrl
    invoice {
      number
      issuedAt
      sentAt
      sentTo
      previousNumbers {
        number
        issuedAt
        reason
      }
    }
  }
}
